/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plus_final_prize: NonNullable<unknown> }} Focus_Pass_Paywall_TitleInputs */

const en_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last Chance to Unlock <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const ar_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`فرصة أخيرة لفتح <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const de_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Letzte Chance, <span style="STYLE">${i?.plus_final_prize}</span> freizuschalten`)
};

const es_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Última oportunidad para desbloquear <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const fr_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière chance de débloquer <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const it_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima possibilità di sbloccare <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const ja_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">${i?.plus_final_prize}</span>をアンロックする最後のチャンス`)
};

const ko_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">${i?.plus_final_prize}</span>을(를) 잠금 해제할 마지막 기회!`)
};

const pt_br_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última chance de desbloquear <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const ru_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Последний шанс разблокировать <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const th_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`โอกาสสุดท้ายในการปลดล็อก <span style="STYLE">${i?.plus_final_prize}</span>`)
};

const tr_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">${i?.plus_final_prize}</span> kilidini açmak için son şans`)
};

const zh_cn_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最后机会解锁<span style="STYLE">${i?.plus_final_prize}</span>`)
};

const zh_tw_focus_pass_paywall_title = /** @type {(inputs: Focus_Pass_Paywall_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最後機會解鎖<span style="STYLE">${i?.plus_final_prize}</span>`)
};

/**
* | output |
* | --- |
* | "Last Chance to Unlock <span style=\"STYLE\">{plus_final_prize}</span>" |
*
* @param {Focus_Pass_Paywall_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_paywall_title = /** @type {((inputs: Focus_Pass_Paywall_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Paywall_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_paywall_title(inputs)
	if (locale === "ar") return ar_focus_pass_paywall_title(inputs)
	if (locale === "de") return de_focus_pass_paywall_title(inputs)
	if (locale === "es") return es_focus_pass_paywall_title(inputs)
	if (locale === "fr") return fr_focus_pass_paywall_title(inputs)
	if (locale === "it") return it_focus_pass_paywall_title(inputs)
	if (locale === "ja") return ja_focus_pass_paywall_title(inputs)
	if (locale === "ko") return ko_focus_pass_paywall_title(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_paywall_title(inputs)
	if (locale === "ru") return ru_focus_pass_paywall_title(inputs)
	if (locale === "th") return th_focus_pass_paywall_title(inputs)
	if (locale === "tr") return tr_focus_pass_paywall_title(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_paywall_title(inputs)
	return zh_tw_focus_pass_paywall_title(inputs)
});